<template>
  <Transition name="drawer">
    <slot />
  </Transition>
</template>
<style lang="scss">

.drawer-enter-active {
  transition: all $transition-time-in $transition-ease-in;
}

.drawer-leave-active {
  transition: all $transition-time-out $transition-ease-out;
}

.drawer-enter-from,
.drawer-leave-to {
  transform: translateX(100%);
}

.drawer-enter-to,
.drawer-leave-from {
  transform: translateX(0);
}

</style>
